export default __webpack_public_path__ + "static/media/clock.d4e0724e.svg";